import { Ability, AbilityBuilder } from '@casl/ability';

import { Operation } from 'common/ability/operation';
import { Subject } from 'common/ability/subject';
import { CompanySubscriptionModel } from '../../units/account/interfaces/company-subscription-model';

Ability.addAlias(Operation.Manage, [
  Operation.Create,
  Operation.Read,
  Operation.Update,
  Operation.Delete,
  Operation.Duplicate,
]);

export class UserAbility {
  private readonly ability: Ability;

  constructor(
    isAdmin: boolean,
    isOwner: boolean,
    subscription: CompanySubscriptionModel | null,
    userRoleName: string,
  ) {
    const { rules, can } = AbilityBuilder.extract();

    // if (!rolePermissions && !isAdmin) {
    //   this.ability = AbilityBuilder.define((_can, _cannot) => {
    //     // can nothing
    //   });
    //   return;
    // }

    if (isOwner && subscription && subscription.isSelfService) {
      can(Operation.Manage, Subject.Billing);
    }

    if (isOwner || userRoleName === 'Administrator') {
      can(Operation.Manage, Subject.Role);
    }

    if (isAdmin) {
      can(Operation.Manage, Subject.AdminPanel);
    }

    this.ability = new Ability(rules);
  }

  /**
   * method for checking ability presence
   */
  public can(operation: Operation, subject: Subject | Subject[] | object, field?: string): boolean {
    return this.ability.can(operation, subject, field);
  }

  /**
   * method for checking ability absence
   */
  public cannot(
    operation: Operation,
    subject: Subject | Subject[] | object,
    field?: string,
  ): boolean {
    return this.ability.cannot(operation, subject, field);
  }
}
